import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Entity, isBlank, Row } from 'gossamer-unified';
import {
  GCacheRecord,
  GCacheState,
  getDefaultGCacheRecordEntry,
  getRecordFromGCache,
  selectRecordFromGCache,
} from './ReduxGCache';

export const useCacheRecord = <T extends Row>(
  entity: Entity<T>,
  key: string | number | null | undefined,
  skip?: boolean,
) => {
  const dispatch = useDispatch();
  const keyStr = isBlank(key) ? '' : String(key);
  const cacheItem =
    useSelector(
      (state: { cache: GCacheState }) => selectRecordFromGCache(state, entity.id, keyStr) as GCacheRecord<T>,
    ) || getDefaultGCacheRecordEntry(entity.id, keyStr);
  const isExpired = cacheItem.expiresAt < Date.now();
  const needsLoad = !skip && !isBlank(key) && (isExpired || (!cacheItem.data && !cacheItem.isFetching));
  useEffect(() => {
    if (needsLoad) {
      dispatch(
        getRecordFromGCache({
          entity,
          key: keyStr,
        }),
      );
    }
  }, [entity.id, keyStr, needsLoad]);
  return cacheItem;
};
